import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import readingsSlice from './readSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    readings: readingsSlice
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch